import React from 'react';

import './styles.css';

const UpgradeButton = ({ onClickUpgrade }) => (
  <div className="action text-center">
    <button
      type="button"
      className="btn btn-lg btn-cta"
      onClick={() => onClickUpgrade()}
    >
      YES, UPGRADE ME!
    </button>
  </div>
);

export default UpgradeButton;
